import { WhiteSpace } from "@aeo/core/components";
import fields from "@aeo/core/fields";
import { useScrollTo } from "@aeo/core/hooks";
import messages from "@aeo/core/messages";
import { capitalize } from "@aeo/core/utils";
import { KeyValueCard, NotesCardForm } from "../components";

export const SecurityFourValues = () => {
  const securityFour = fields.securityFour;

  //If id of mention exists in url scroll to it.
  useScrollTo();

  return (
    <>
      <h4>{capitalize(messages.titles.securityRequirements)}</h4>
      <WhiteSpace />

      <KeyValueCard {...securityFour.verification_identity_partners} />
      <KeyValueCard {...securityFour.safety_partner_requirements} />
      <KeyValueCard {...securityFour.safety_partner_procedure} />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.has_partner_breaches} type="boolean" />
      <KeyValueCard {...securityFour.partner_breaches} NA />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.staffSecurity)}</h4>
      <WhiteSpace />

      <KeyValueCard {...securityFour.security_requirements} />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.has_security_procedure} type="boolean" />
      <KeyValueCard
        {...securityFour.security_procedure_attachments}
        type="attachments"
      />
      <KeyValueCard {...securityFour.security_procedure} NA />
      <WhiteSpace v="1rem" />

      <div className="color-gray">{securityFour.title_6_11_2.title}</div>

      <KeyValueCard {...securityFour.checking_new_employees} />
      <KeyValueCard {...securityFour.checking_old_employees} />
      <KeyValueCard {...securityFour.access_employees} />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.has_safety_training} type="boolean" />
      <KeyValueCard {...securityFour.safety_training} NA />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.has_annual_course} type="boolean" />
      <KeyValueCard
        {...securityFour.has_conducted_sessions}
        type="boolean-place"
      />
      <KeyValueCard {...securityFour.has_sessions_register} type="boolean" />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.fixed_term_employee} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityFour.has_security_standards} type="boolean" />
      <KeyValueCard {...securityFour.security_standards} NA />
      <WhiteSpace v="1rem" />

      <KeyValueCard
        {...securityFour.has_employee_instructions}
        type="boolean"
      />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.contractedServices)}</h4>
      <WhiteSpace />

      <KeyValueCard {...securityFour.has_contractual_services} type="boolean" />
      <KeyValueCard {...securityFour.contractual_services} NA />
      <WhiteSpace v="1rem" />

      <KeyValueCard {...securityFour.has_written_agreements} type="boolean" />
      <KeyValueCard {...securityFour.written_agreements} NA />
      <WhiteSpace v="1rem" />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.requiredDocuments)}</h4>
      <WhiteSpace />
      <KeyValueCard {...securityFour.attachments} type="attachments" />
    </>
  );
};

export const SecurityFour = () => {
  return (
    <NotesCardForm
      title={messages.SAQTabs.security.title}
      content={<SecurityFourValues />}
      path="saq/security_four"
    />
  );
};
